<template>
  <div class="page-title">
    隱私權條款
  </div>
  <div class="page-container">
    <div class="content">
      非常歡迎您光臨「CHW Watch」（以下簡稱本應用程式），為了讓您能夠安心使用本應用程式的各項服務與資訊，特此向您說明本應用程式的隱私權保護政策，以保障您的權益，請您詳閱下列內容：<br/>
      <br/>
      <span class="sub-title">1. 適用範圍</span><br/>
      本隱私權保護政策內容，包括本應用程式如何處理您使用服務時收集到的個人識別資料。本政策不適用於其他第三方網站或服務，亦不適用於非由本應用程式所委託或參與管理的人員。<br/>
      <br/>
      <span class="sub-title">2. 個人資料的蒐集、處理及利用方式</span><br/>
      當您使用本應用程式時，我們可能會收集您提供的姓名、電子郵件地址、裝置資訊及使用時間等資料。<br/>
      我們僅會在特定目的範圍內使用您的個人資料，例如：提供水資源監測服務、警報通知、數據管理與報表功能。<br/>
      除非另行取得您的書面同意，否則本應用程式不會將您的個人資料用於其他用途。<br/>
      <br/>
      <span class="sub-title">3. 資料之保護</span><br/>
      本應用程式主機設有防火牆、防毒系統等資訊安全設備，以保護您的個人資料。<br/>
      只有經過授權的工作人員才能存取您的個人資料，且均簽有保密協議。<br/>
      <br/>
      <span class="sub-title">4. 資料共享與揭露</span><br/>
      本應用程式不會任意提供您的個人資料給第三方，但在以下情況例外：<br/>
      經由您書面同意。<br/>
      法律明文規定。<br/>
      為免除您生命、身體、自由或財產上之危險。<br/>
      為完成與您之服務所需，且第三方已承諾保密義務。<br/>
      <br/>
      <span class="sub-title">5. Cookie 的使用</span><br/>
      本應用程式使用 Cookies 來提升您的使用體驗，這些 Cookies 僅用於分析使用行為與改善服務，並不會用於識別您的身份。<br/>
      您可在瀏覽器中設定拒絕接受 Cookies，但可能導致部分功能無法正常使用。<br/>
      <br/>
      <span class="sub-title">6. 未成年人的保護</span><br/>
      本應用程式僅適用於 16 歲以上之使用者，若使用者未滿 16 歲，需經由法定代理人同意方可使用。<br/>
      <br/>
      <span class="sub-title">7.隱私權保護政策之修訂</span><br/>
      本應用程式保留隨時修改本隱私權保護政策的權利，修改後的條款將即時公佈於應用程式內。<br/>
      <br/>
      <span class="sub-title">8. 聯繫方式</span><br/>
      若您對本隱私權政策有任何疑問，或希望檢視、更正、刪除您的個人資料，請透過以下方式聯繫我們：<br/>
      公司名稱：「好事創新」<br/>
      電子郵件：isonitccs@gmail.com<br/>
    </div>
  </div>
</template>

<style scoped>

.page-title {
  background-color: blue;
  margin: 0;
  padding: 38px 0;
  font-size: 24px;
  font-weight: bold;
  color: white;
  text-align: center;
}

.page-container {
  display: flex;
  justify-content: center;
}

.content {
  background-color: white;
  width: fit-content;
  padding: 40px 50px;
}

.sub-title {
  font-weight: bold;
}
</style>
